<template>
    <a-card size="small" title="报文处理">
        <searchE @handleSearch="handleSubmit"></searchE>
        <tableE ref="processTable"></tableE>
    </a-card>
</template>
<script>
import searchE from './search'
import tableE from './table'
export default {
    methods: {
        handleSubmit(searchP){
            this.$refs.processTable.handleSearch(searchP);
        }
    },
    components:{
        searchE,
        tableE
    },
};
</script>
